import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import { connect } from 'react-redux';
import { patchUser, clearPatchUser } from 'redux/settings/actions';
import { fetchMe } from 'redux/users/actions';

import './EmailUnsubscribe.css';
import {Checkbox} from "semantic-ui-react";


const EmailUnsubscribe = props => {
  const {
    me,
    patchUser,
    clearPatchUser,
    patchUserSuccess,
    fetchMe
  } = props;
  const { t } = useTranslation();

  useEffect(() => {
    if (patchUserSuccess) {
      fetchMe(false);
      clearPatchUser();
    }
  }, [patchUserSuccess]);

  const onEmailUnsubscibeChange = (_e, { checked }) => {
    const form = new FormData();
    form.append('unsubscribe', !checked);
    patchUser(form);
  };

  return (
    <div className="email-unsubscribe__component">
      <div className="label-wrapper">
        <div className="label-text">
          {t("Turn On / Off email notifications and promotional materials from HeyLink.me")}
        </div>
        <div className="checkbox-wrapper">
          <div className="option">{t("OFF")}</div>
          <Checkbox
            key="email-unsubscribe-checkbox-key"
            toggle
            checked={!me.unsubscribed_at}
            onChange={onEmailUnsubscibeChange}
          />
          <div className="option">{t("ON")}</div>
        </div>
      </div>
    </div>
  );
};

EmailUnsubscribe.propTypes = {
  me: PropTypes.object,
  patchUser: PropTypes.func.isRequired,
  clearPatchUser: PropTypes.func.isRequired,
  fetchMe: PropTypes.func.isRequired,
  patchUserSuccess: PropTypes.object,
  patchUserError: PropTypes.object,
};

EmailUnsubscribe.defaultProps = {
  me: null,
};


const mapStateToProps = state => (
  {
    me: state.usersReducer.me,
    patchUserSuccess: state.settingsReducer.patchUserSuccess,
    patchUserError: state.settingsReducer.patchUserError,
  }
);

export default connect(
  mapStateToProps,
  {
    patchUser,
    clearPatchUser,
    fetchMe,
  },
)(EmailUnsubscribe);
